import { Component, Input } from '@angular/core';
import { Router, NavigationExtras } from '@node_modules/@angular/router';

import { lastValueFrom } from 'rxjs/internal/lastValueFrom';

import { HotMarket, Job } from '@app/models';
import { HotMarketService, JobService } from '@app/services';

@Component({
    selector: 'jobs-by-markets',
    templateUrl: './jobs-by-markets.component.html',
    styleUrls: ['./jobs-by-markets.component.scss'],
    standalone: false
})
export class JobsByMarketsComponent {
  @Input() featuredOnly: boolean = false;

  jobMarkets: HotMarket[] = [];
  // tempJobs: Job[] = null;
  // _tempJob: Job = null;

  constructor(
    private _router: Router,
    private _hotMarketService : HotMarketService,
    private _jobsService: JobService
  ) {}


  ngOnInit() {
    this.getJobMarkets();
    // this.getTempJobs();
  }


  async getJobMarkets() {
    const marketsSearch = new HotMarket();

    if (this.featuredOnly) {
      marketsSearch.featured = true;
    }

    const _marketSearch = await lastValueFrom(this._hotMarketService.selectAllSearch(marketsSearch));
    // console.log('Job Markets pre sort: ', _marketSearch);

    this.jobMarkets = _marketSearch
      .filter(_market => {
        // console.log('Checking market: ', _market);
        return _market?.jobs?.length;
      })
      .sort((a, b) => {
        const nameA = a.city.toUpperCase(); // Ignore case for consistent sorting
        const nameB = b.city.toUpperCase(); // Ignore case for consistent sorting

        if (nameA < nameB) {
          return -1; // a comes before b
        }
        if (nameA > nameB) {
          return 1; // b comes before a
        }
        return 0; // names are equal
      });

    // console.log('this.jobMarkets: ', this.jobMarkets);
  }


  goToHotMarketDetails(_market) {
    if (_market != undefined && _market._id != undefined) {
      this._hotMarketService.setHotMarketToBeViewed(_market);
      const nameParam = (_market.name != undefined) ? _market.name.replace(/\s+/g, '-').toLowerCase() : 'unknown';

      window.scrollTo({
        top: 0, // Scroll to the top (y-coordinate 0)
        behavior: 'smooth' // Enable smooth animation
      });

      this._router.navigate(['/hot-markets/' + nameParam]);
    }
  }  


  sendToDetails(_job: Job) {
    if (_job.job_id && _job.job_id !== undefined) {
      this._jobsService.setJobToBeViewed(_job);

      // const professionForJobUrl = (_job.urlParts != undefined && _job.urlParts.profession != undefined) ? _job.urlParts.profession : null;
      // const stateForJobUrl = (_job.urlParts != undefined && _job.urlParts.state != undefined) ? _job.urlParts.state : null;
      // const cityForJobUrl = (_job.urlParts != undefined && _job.urlParts.city != undefined) ? _job.urlParts.city : null;
      // const jobIdForJobUrl = (_job.job_id != undefined) ? _job.job_id : null;

      // const jobLink = `/job-search/${professionForJobUrl}/${stateForJobUrl}/${cityForJobUrl}/${jobIdForJobUrl}`;
      // console.log('Job Link: ', jobLink);

      const searchTerms = new Job();
      searchTerms.profession = _job.profession;

      const navigationExtras: NavigationExtras = {
        state: {
          data: {
            searchTerms: searchTerms
          }
        }
      };

      this._router.navigate(['/job-search'], navigationExtras);

      // this._router.navigate([jobLink]);
      
      // document.location = jobLink;
    }
  }  
}
